import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
interface CircleTickProps extends SVGProps<SVGSVGElement> {
  circleClassName?: string;
  tickClassName?: string;
  className?: string;
}
export const CircleTick: FC<CircleTickProps> = t0 => {
  const $ = _c(14);
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      circleClassName: t1,
      tickClassName: t2,
      className: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  const circleClassName = t1 === undefined ? "fill-current" : t1;
  const tickClassName = t2 === undefined ? "stroke-current" : t2;
  const className = t3 === undefined ? "text-white" : t3;
  let t4;
  if ($[5] !== circleClassName) {
    t4 = <circle cx="12" cy="12" r="11" className={circleClassName} />;
    $[5] = circleClassName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== tickClassName) {
    t5 = <path d="M18 8L10.4375 15.5625L7 12.125" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={tickClassName} />;
    $[7] = tickClassName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== className || $[10] !== props || $[11] !== t4 || $[12] !== t5) {
    t6 = <svg width="24" height="24" viewBox="0 0 24 24" className={className} xmlns="http://www.w3.org/2000/svg" {...props}>{t4}{t5}</svg>;
    $[9] = className;
    $[10] = props;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};